import React from "react";

const TickIcon = () => {
  return (
    <svg
      width="20"
      height="12"
      viewBox="0 0 20 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.7803 2.61951C11.0732 2.9124 11.0732 3.38728 10.7803 3.68017L4.6835 9.77709C4.54133 9.91926 4.34802 9.9984 4.14697 9.99674C3.94592 9.99508 3.75395 9.91276 3.61414 9.76826L1.21101 7.28438C0.922994 6.98669 0.930839 6.51188 1.22853 6.22386C1.52622 5.93585 2.00103 5.94369 2.28905 6.24139L4.16199 8.17726L9.71967 2.61952C10.0126 2.32662 10.4874 2.32662 10.7803 2.61951Z"
        fill="#4C70EF"
      />
    </svg>
  );
};

export default TickIcon;
